const Icon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#575BFD" fillOpacity="0.12" />
    <g clipPath="url(#clip0_700_1311)">
      <path
        d="M19.9524 11.5734C19.9574 11.5582 19.962 11.5517 19.9632 11.5502C19.9645 11.5485 19.9654 11.5476 19.9667 11.5468C19.9701 11.5445 19.9814 11.5389 20 11.5389C20.0186 11.5389 20.0299 11.5445 20.0333 11.5468C20.0346 11.5476 20.0355 11.5485 20.0368 11.5502C20.038 11.5517 20.0426 11.5582 20.0476 11.5734L21.5768 16.2798C21.7843 16.9184 22.3794 17.3508 23.0509 17.3508H27.9995C28.0155 17.3508 28.023 17.3532 28.0248 17.3538C28.0269 17.3545 28.028 17.3552 28.0292 17.3561C28.0325 17.3587 28.0413 17.3677 28.047 17.3854C28.0528 17.403 28.0509 17.4155 28.0498 17.4195C28.0494 17.421 28.0489 17.4221 28.0476 17.4239C28.0465 17.4255 28.0418 17.4319 28.0289 17.4413L24.0254 20.35C23.4821 20.7447 23.2548 21.4443 23.4623 22.0829L24.9915 26.7893C24.9964 26.8045 24.9965 26.8125 24.9965 26.8144C24.9964 26.8165 24.9961 26.8178 24.9956 26.8192C24.9942 26.8231 24.9884 26.8343 24.9733 26.8452C24.9583 26.8561 24.9459 26.8583 24.9417 26.8584C24.9402 26.8584 24.9389 26.8583 24.9369 26.8577C24.935 26.8571 24.9275 26.8546 24.9146 26.8452L20.9111 23.9365C20.3678 23.5418 19.6322 23.5418 19.0889 23.9365L15.0854 26.8452C15.0725 26.8546 15.065 26.8571 15.0631 26.8577C15.0611 26.8583 15.0598 26.8584 15.0583 26.8584C15.0541 26.8583 15.0417 26.8561 15.0267 26.8452C15.0116 26.8343 15.0058 26.8231 15.0044 26.8192C15.0041 26.8186 15.004 26.818 15.0038 26.8174C15.0037 26.8166 15.0036 26.8156 15.0035 26.8144C15.0035 26.8125 15.0036 26.8045 15.0085 26.7893L16.5377 22.0829C16.7452 21.4443 16.5179 20.7447 15.9746 20.35L11.9711 17.4413C11.9582 17.4319 11.9535 17.4255 11.9524 17.4239C11.9511 17.4221 11.9506 17.421 11.9502 17.4195C11.9491 17.4155 11.9472 17.403 11.953 17.3854C11.9587 17.3677 11.9675 17.3587 11.9708 17.3561C11.972 17.3552 11.9731 17.3545 11.9752 17.3538C11.977 17.3532 11.9845 17.3508 12.0005 17.3508H16.9491C17.6206 17.3508 18.2157 16.9184 18.4232 16.2798L19.9524 11.5734Z"
        stroke="#575BFD"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_700_1311">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
